import { Outlet } from 'react-router'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { uiStore } from 'shared/store/uiStore'
import { SpinnerLoader } from 'shared/ui'
import { BillingRoutes, ConversationRoutes } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { SettingsRoutes } from 'pages/settings/route/type'

export const BillingAccessLayout = observer(() => {
  const { subscriptionStore, userPermissionsStore } = useEntitiesContext()

  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    Promise.all([subscriptionStore.initPromise, userPermissionsStore.initPromise]).then(() => {
      const can_manage_billing_settings = userPermissionsStore.getItem(
        'can_manage_billing_settings'
      )

      if (!can_manage_billing_settings) {
        uiStore.changeRoute({
          path: `/${ConversationRoutes.root}`,
        })
        return
      }
      if (subscriptionStore.isCanceled) {
        uiStore.changeRouteViaVue({
          path: `/${SettingsRoutes.root}/${BillingRoutes.upgrade}`,
        })
        return
      }

      setLoading(false)
    })
  }, [])

  if (loading) return <SpinnerLoader ariaLabel={'AccessLayout'} />

  return <Outlet />
})
